export default __webpack_public_path__ + "static/AppleiMac-5d659b458e485f0a95e701c2e4c10f81.png";